import { render, staticRenderFns } from "./MessageTemplateByMembership.vue?vue&type=template&id=d48319c8&scoped=true"
import script from "./MessageTemplateByMembership.vue?vue&type=script&lang=js"
export * from "./MessageTemplateByMembership.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateByMembership.vue?vue&type=style&index=0&id=d48319c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48319c8",
  null
  
)

export default component.exports